module.exports = __webpack_public_path__ + "static/media/lottery_event@3x.f2b45b8d.webp";